import axios from "axios";

/** Unauthenticated API client (e.g. public branding). Does not attach operator JWT or redirect on 401. */
const publicApiClient = axios.create({
  baseURL: "https://localhost:7008/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default publicApiClient;
